import { MeetingSourceCall as SourceCall } from "@/interfaces/DashboardMeetingStats";
import { DateTime } from "luxon";
import { Link } from "react-router-dom";

const date = (value: string) =>
  DateTime.fromISO(value)
    .setZone("Europe/Paris")
    .toFormat("dd/MM/yyyy à HH:mm");
export default function MeetingSourceCall({
  call,
  companyId,
}: {
  call?: SourceCall | null;
  companyId: string | null;
}) {
  if (call === undefined) return <span>—</span>;
  if (!call) return <span>Sans appel associé</span>;
  const actor =
    call.actorAttribution === "verified" && call.actorName
      ? call.actorName
      : "Auteur non identifié";
  return (
    <details>
      <summary>
        {date(call.startedAt)}
        <small>{actor}</small>
      </summary>
      <small>
        {call.direction === "in"
          ? "Appel entrant"
          : call.direction === "out"
            ? "Appel sortant"
            : "Sens non renseigné"}
        {call.durationS != null &&
          ` · ${Math.floor(call.durationS / 60)} min ${call.durationS % 60} s`}
      </small>
      {call.endedAt && <small>Fin : {date(call.endedAt)}</small>}
      <small>
        Dernier appel décroché du client avant la création du RDV, dans le délai
        de 24 h.
      </small>
      {companyId && (
        <Link
          className="d-inline-block mt-2"
          to={`/companies/${companyId}?tab=calls`}
        >
          Voir les appels du client
        </Link>
      )}
    </details>
  );
}
